var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"24","width":"24","viewBox":"0 0 24 24","fill":"currentColor"}},_vm.$listeners),[_c('path',{attrs:{"d":"M22 4V2H2v2zM22 8V6H2v2h9v10.17l-5.5-5.5-1.42 1.41L12 22l7.92-7.92-1.42-1.41-5.5 5.5V8z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }